import { render } from "./RegisterView.vue?vue&type=template&id=32cc3e56&scoped=true"
import script from "./RegisterView.vue?vue&type=script&lang=js"
export * from "./RegisterView.vue?vue&type=script&lang=js"

import "./RegisterView.vue?vue&type=style&index=0&id=32cc3e56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cc3e56"]])

export default __exports__